import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IsLoading, LoadingWrapper } from 'src/app/shared/decorators';
import { SearchWeeklySummaryDto } from 'src/app/shared/dto';
import { DashboardApiService } from 'src/app/shared/services/api';

const LOADER_SEARCH_SUMMARY: string = "search-summary";

@Component({
    selector: 'app-searches-card-container',
    templateUrl: './searches-card-container.component.html',
    styleUrls: ['../../common-reporting-dashboard.scss'],
    standalone: false
})
export class SearchesCardContainerComponent {
    @IsLoading(LOADER_SEARCH_SUMMARY) isSessionSummaryLoading$: Observable<boolean>;

    isShowChart: boolean = true;

    searchSummary$: Observable<SearchWeeklySummaryDto[]>;

    constructor(private readonly dashboardApiService: DashboardApiService) {
        this.searchSummary$ = this.getSearchSummary().pipe(
            map(searches => searches.map(search => ({
                ...search,
                portalSearchCount: search.portalSearchCount || 0,
                revdriverSearchCount: search.revdriverSearchCount || 0,
                totalSearchCount: (search.portalSearchCount || 0) + (search.revdriverSearchCount || 0)
            })))
        );
    }

    @LoadingWrapper(LOADER_SEARCH_SUMMARY)
    private getSearchSummary(): Observable<SearchWeeklySummaryDto[]> {
        return this.dashboardApiService.getSearchSummary()
    }

}
